import * as React from 'react';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { PD_ALERT_TITLE_LABEL, PD_ALERT_MESSAGE_LABEL } from '../../types.js';

const PrescriptionFormPupillaryDistanceAlert = ({ className  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(Alert, {
        variant: "info",
        title: getLabel(PD_ALERT_TITLE_LABEL),
        className: `alert-m-default ${className}`
    }, getLabel(PD_ALERT_MESSAGE_LABEL));
};

export { PrescriptionFormPupillaryDistanceAlert };
//# sourceMappingURL=PrescriptionFormPupillaryDistanceAlert.js.map
